import { chatApi } from "../../services/chatService";
import { AsyncSelectField } from "./asyncSelectField";

export const PatientSearchField = ({ control, name, rules, title, errors, defaultValue, onChange, isDisabled, isMulti, location = ""}) => {
    const [getPatients] = chatApi.endpoints.getPatients.useLazyQuery();
    
    const search =  async (query) => {
        if (query?.length > 2) {
            let response = await getPatients({ keyword:query, location_id: location })
            return response?.data.map((value) => ({
                ...value, label:value?.full_name
            }))
        }
    }

    return (<>
        <AsyncSelectField
            defaultValue={defaultValue}
            search={search}
            title={title}
            name={name}
            control={control}
            rules={rules}
            errors={errors}
            onChange={
                onChange ? onChange : null
            }
            isDisabled = {isDisabled}
            isMulti={isMulti}
        />
    </>)
}